// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"be967c36","83":"c806125b","115":"b87a8de3","148":"7b2fe440","204":"1e3d0a84","206":"d3679cab","242":"f239919a","453":"60950a58","455":"51fd20ed","710":"fabe01e3","825":"b3d49440"}[chunkId] + ".chunk.js";
};